import AsyncStorage from '@react-native-async-storage/async-storage';

const SUBTITLE_LANG_CACHE_KEY = 'player-subtitle-language';

/**
 * Subtitle cache should return null if the value is not set
 * @returns number | undefined
 */
export function getSubtitleLanguage(): Promise<string | null> {
  return AsyncStorage.getItem(SUBTITLE_LANG_CACHE_KEY);
}

export function setSubtitleLanguage(lang: string): void {
  AsyncStorage.setItem(SUBTITLE_LANG_CACHE_KEY, lang);
}
